import React from 'react';
import classNames from 'classnames';

import { hasHelpChannels } from '../../config/communityChannels';
import { CommunityAskBar } from '../CommunityChannels/CommunityChannels';

import css from './SimpleAppExperience.module.css';

/**
 * Declares cold-start operating modes so empty liquidity does not block production use.
 * Browse seeded catalog · Concierge human match · Post a request.
 */
const ColdStartModes = ({ appId, className, onRequest, requestLabel = 'Post a request' }) => {
  const conciergeReady = hasHelpChannels();

  return (
    <section
      className={classNames(css.coldStart, className)}
      data-testid="cold-start-modes"
      aria-label="How to get started"
    >
      <h2 className={css.sectionTitle}>How it works today</h2>
      <p className={css.promise}>
        Live network — you do not need a full marketplace of strangers to start. Pick a path:
      </p>
      <ol className={css.coldStartList}>
        <li>
          <strong>Browse seed providers</strong>
          <span> — operator-seeded directory so the catalog is never empty.</span>
        </li>
        <li>
          <strong>Post a request</strong>
          <span> — we save it to your account and run a smart-match window.</span>
        </li>
        <li>
          <strong>Concierge match</strong>
          <span>
            {conciergeReady
              ? ' — WhatsApp / Telegram ops finds a real person when the directory does not fit.'
              : ' — ask ops once community channels are configured.'}
          </span>
        </li>
      </ol>
      <p className={css.cardMeta}>
        Settlement: cash + handoff PIN by default. Wallet escrow is optional when both parties choose
        it.
      </p>
      <div className={css.actionRow}>
        {onRequest ? (
          <button
            type="button"
            className={css.primaryBtn}
            onClick={onRequest}
            data-testid="cold-start-request"
          >
            {requestLabel}
          </button>
        ) : null}
      </div>
      {conciergeReady ? (
        <CommunityAskBar
          appId={appId}
          prompt="Skip the directory — ask ops to find someone"
        />
      ) : null}
    </section>
  );
};

export default ColdStartModes;
